<template>
  <ProductSelector
    ref="productSelector"
    endpoint="food"
    :data="data"
    :errors="errors"
    dataKey="foodDrinks"
    :packageType="packageType"
    :isMailboxSession="isMailboxSession"
    :flowType="flowType"
    :currentStep="currentStep"
    @update="onUpdate"
  />
</template>

<script>
import ProductSelector from '../templates/ProductSelector.vue';
import { initializeProduct } from '../utils/productCountUtils.js';

export default {
  name: 'FoodAndDrinks',
  components: { ProductSelector },
  props: {
    data: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    endpoint: { type: String, required: true },
    packageType: { type: String, default: 'large' },
    mode: { type: String, default: null },
    isMailboxSession: { type: Boolean, default: false },
    flowType: { type: String, default: 'compose' },
    currentStep: { type: Number, default: 0 },
  },
  emits: [
    'update',
    'next',
    'go-to-step',
    'reset-package',
    'start',
    'increase-product',
    'decrease-product',
    'add-to-cart',
    'remove-product',
    'remove-food',
    'remove-packaging',
    'select-base',
    'printing-updated',
    'remove-base-package',
  ],
  mounted() {
    this.setupEventListeners();

    // Only load base package food drinks if we don't already have food drinks data
    // This prevents overwriting cart-loaded data
    if (
      this.data &&
      this.data.basePackage?.id &&
      (!this.data.foodDrinks || this.data.foodDrinks.length === 0)
    ) {
      fetch(`/api/packages/${this.data.basePackage.id}`)
        .then((res) => res.json())
        .then((pakket) => {
          if (Array.isArray(pakket.foodDrinks)) {
            const selectedFoodDrinks = pakket.foodDrinks.map((p) =>
              initializeProduct(p, p.count || 1),
            );
            this.$emit('update', { foodDrinks: selectedFoodDrinks });
          }
        });
    }
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
  methods: {
    onUpdate(payload) {
      if (payload.foodDrinks) {
        this.$emit('update', { foodDrinks: payload.foodDrinks });
      }
    },
    setupEventListeners() {
      this.reloadHandler = () => {
        if (this.$refs.productSelector) {
          this.$refs.productSelector.fetchProducts();
        }
      };
      document.addEventListener('s7_reload_products', this.reloadHandler);
    },
    removeEventListeners() {
      if (this.reloadHandler) {
        document.removeEventListener('s7_reload_products', this.reloadHandler);
      }
    },
  },
};
</script>
